<template>
    <div>
        <router-link tag="a" class="back-button right mb11" to="/portfolio">Back to portfolio</router-link>
        <h6 class="headline-sm">Churches</h6>
        <ul class="portfolio-list">
            <li>
                <img img src="images/Our-Work-Page/Churches/churches1.png" alt="">
                <strong class="portfolio-list-name">St. Francis De Sales<br/>Catholic Church</strong>
                <span class="portfolio-list-location">Abingdon, MD</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Churches/churches2.png" alt="">
                <strong class="portfolio-list-name">Hebron Lutheran Church</strong>
                <span class="portfolio-list-location">Madison, VA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Churches/churches3.png" alt="">
                <strong class="portfolio-list-name">St. Mary’s Roman<br/>Catholic Church</strong>
                <span class="portfolio-list-location">Ridgefield, CT</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Churches/churches4.png" alt="">
                <strong class="portfolio-list-name">Congregation Beth Am</strong>
                <span class="portfolio-list-location">San Diego, CA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Churches/churches5.png" alt="">
                <strong class="portfolio-list-name">St. Anne’s Home -<br/> Little Sister of the Poor</strong>
                <span class="portfolio-list-location">San Francisco, CA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Churches/churches6.png" alt="">
                <strong class="portfolio-list-name">St. Eugene’s Cathedral</strong>
                <span class="portfolio-list-location">Santa Rosa, CA</span>
            </li>
        </ul>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'churches',
        metaInfo: {
            title: 'Churches'
        }
    }
</script>



// WEBPACK FOOTER //
// Churches.vue?0eca0426